import dayjs, { Dayjs, isDayjs } from 'dayjs';

/** 获取过期时间戳 */
export const getExpiresDate = (day: number) => {
  return Date.now() + day * 1000 * 60 * 60 * 24;
};

/** 判断当前时间是否在给到的时间 + x天之内 */
export const isDuringNowAfterDate = (date: string | number | Dayjs, day: number) => {
  const now = dayjs(new Date());
  const startDate = dayjs(isDayjs(date) ? date : new Date(Number(date)));
  const endDate = startDate.add(day, 'day');

  return now.isAfter(startDate) && now.isBefore(endDate);
};

/** 判断当前时间是否在给到的时间 + x分钟内 */
export const isDuringNowAfterMinute = (date: string | number | Dayjs, minute: number) => {
  const now = dayjs(new Date());
  const startDate = dayjs(isDayjs(date) ? date : new Date(Number(date)));
  const endDate = startDate.add(minute, 'minute');

  return now.isAfter(startDate) && now.isBefore(endDate);
};
